import { render, staticRenderFns } from "./AsACoachPage.vue?vue&type=template&id=60a2210b&scoped=true"
import script from "./AsACoachPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AsACoachPage.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AsACoachPage.vue?vue&type=style&index=0&id=60a2210b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a2210b",
  null
  
)

export default component.exports